import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContent } from '../../types';
import {
  GameSliderContainer,
  GameSliderDescription,
  GameSliderTitle
} from './GameSliderBlockStyle';
import DesktopSlider from './DesktopSlider/DesktopSlider';
import MobileSlider from './MobileSlider/MobileSlider';


interface IGameSliderProps {
  context? : IContent;
}

const GameSliderBlock = ({context} : IGameSliderProps) => {
  return (
    <GameSliderContainer>
      <GameSliderTitle>{context.gameSlider.title}</GameSliderTitle>
      <GameSliderDescription>{context.gameSlider.description}</GameSliderDescription>
      <DesktopSlider/>
      <MobileSlider/>
    </GameSliderContainer>
  );
};

export default withContent(GameSliderBlock);